var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-112"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.41,
    y: 320.19,
    width: 26.48,
    height: 11.19,
    transform: "translate(851.29 651.57) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.18,345.49l13.35-.28,6.58-.11c2.19-.05,4.37,0,6.55-.06l-.45.45,0-11.19.5.5-13.24-.06c-4.41,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.08,3.67-.13,5.53Zm0,0L427,340c-.05-1.86-.12-3.75-.13-5.65V334h.28c4.41-.06,8.83-.16,13.24-.17l13.24-.06h.5v.5l-.06,11.19v.45h-.44c-2.23,0-4.47,0-6.7-.05l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.14,235.58l13.36-.28,6.57-.11c2.19-.05,4.37,0,6.55-.05l-.45.44-.05-11.19.5.5-13.24-.06c-4.41,0-8.83-.11-13.24-.17l.27-.27c0,1.83-.08,3.67-.13,5.54Zm0,0L232,230c-.05-1.86-.11-3.75-.13-5.65v-.27h.28c4.41-.05,8.83-.16,13.24-.17l13.24-.06h.5v.5l-.05,11.19V236h-.44c-2.23,0-4.47,0-6.69-.06l-6.67-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.91,
    y: 238.5,
    width: 26.48,
    height: 11.19,
    transform: "translate(520.3 488.19) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.14,249.69l13.36-.28,6.58-.11c2.19-.05,4.36,0,6.54-.05l-.44.44-.06-11.19.5.5-13.24-.06c-4.41,0-8.82-.11-13.24-.17l.28-.27c0,1.83-.09,3.67-.13,5.54Zm0,0-.14-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.27c4.42,0,8.83-.16,13.24-.17l13.24-.06h.51v.5l-.05,11.19v.45h-.45c-2.23,0-4.47,0-6.69-.06l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.92,
    y: 96.77,
    width: 26.48,
    height: 11.19,
    transform: "translate(572.31 204.73) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.34,345.49l13.36-.28,6.58-.11c2.18-.05,4.36,0,6.54-.06l-.44.45-.06-11.19.5.5-13.24-.06c-4.41,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.08,3.67-.13,5.53Zm0,0L46.2,340c-.05-1.86-.11-3.75-.13-5.65V334h.27c4.41-.06,8.83-.16,13.24-.17l13.24-.06h.5v.5l0,11.19v.45h-.45c-2.23,0-4.47,0-6.69-.05l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.11,62.2l13.36-.28,6.58-.11c2.19-.05,4.36,0,6.54-.06l-.44.45L87.09,51l.5.5-13.24-.06c-4.41,0-8.82-.12-13.24-.17l.28-.27c0,1.83-.09,3.67-.14,5.54Zm0,0L61,56.66c0-1.86-.11-3.75-.13-5.65v-.27h.27c4.42-.05,8.83-.16,13.24-.17l13.24-.06h.51V51L88,62.2v.45h-.45c-2.23,0-4.47,0-6.69-.06l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.34,
    y: 65.12,
    width: 26.48,
    height: 11.19,
    transform: "translate(119.16 141.43) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.18,62.2l13.35-.28,6.58-.11c2.19-.05,4.37,0,6.55-.06l-.45.45,0-11.19.5.5-13.24-.06c-4.41,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.08,3.67-.13,5.54Zm0,0L427,56.66c-.05-1.86-.12-3.75-.13-5.65v-.27h.28c4.41-.05,8.83-.16,13.24-.17l13.24-.06h.5V51L454.1,62.2v.45h-.44c-2.23,0-4.47,0-6.7-.06l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.32,
    y: 381.77,
    width: 71.95,
    height: 79.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.17,
    y: 381.77,
    width: 37.15,
    height: 79.68,
    transform: "translate(157.5 843.22) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.73,456q4.14-8.5,8.18-17L79,421.77l8-17.21q4-8.62,7.84-17.3-4.14,8.5-8.18,17.05l-8.06,17.14-8,17.21Q66.61,447.29,62.73,456Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.73,387.26q3.88,8.69,7.84,17.3l8,17.21,8.06,17.14q4.05,8.55,8.18,17-3.88-8.68-7.84-17.3l-8-17.21-8.06-17.14Q66.86,395.76,62.73,387.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.32,
    y: 261.44,
    width: 71.95,
    height: 74.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.17,
    y: 261.44,
    width: 37.15,
    height: 74.19,
    transform: "translate(157.5 597.07) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.19 278.66 128.72 278.66 129.86 278.66 130.51 277.33 131.43 278.66 132.67 275.93 133.85 278.66 137.22 278.66 138.75 278.66 139.31 276.84 139.83 278.66 140.83 278.66 140.83 261.44 127.19 261.44 127.19 278.66",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.73,330.9Q66.87,323,70.91,315l8.06-16,8-16q4-8,7.84-16.11-4.14,7.92-8.18,15.88l-8.06,15.95-8,16Q66.61,322.81,62.73,330.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.73,266.93Q66.61,275,70.57,283l8,16,8.06,16q4.05,8,8.18,15.88-3.88-8.08-7.84-16.11l-8-16-8.06-15.95Q66.86,274.85,62.73,266.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.06,
    y: 323.03,
    width: 7.99,
    height: 7.99,
    transform: "translate(212.11 654.05) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.53,
    y: 335.63,
    width: 71.95,
    height: 46.14,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.38,
    y: 335.63,
    width: 37.15,
    height: 46.14,
    transform: "translate(147.91 717.4) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.4 352.85 123.92 352.85 125.07 352.85 125.72 351.52 126.64 352.85 127.88 350.12 129.06 352.85 132.42 352.85 133.96 352.85 134.51 351.03 135.04 352.85 136.04 352.85 136.04 335.63 122.4 335.63 122.4 352.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.94,379q4.13-5,8.18-10.09l8.06-10.14,8-10.19q3.94-5.1,7.83-10.24-4.12,5-8.18,10.09l-8.06,10.15-8,10.18Q61.82,373.89,57.94,379Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.94,338.37q3.89,5.14,7.84,10.24l8,10.19,8.06,10.14Q85.84,374,90,379q-3.87-5.14-7.83-10.24l-8-10.18-8.06-10.15Q62.07,343.41,57.94,338.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.67,
    y: 391.75,
    width: 71.95,
    height: 69.7,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.52,
    y: 391.75,
    width: 37.15,
    height: 69.7,
    transform: "translate(708.2 853.2) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.54 408.97 404.06 408.97 405.21 408.97 405.86 407.64 406.78 408.97 408.02 406.24 409.2 408.97 412.56 408.97 414.1 408.97 414.66 407.14 415.18 408.97 416.18 408.97 416.18 391.75 402.54 391.75 402.54 408.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.08,457.3q4.13-7.59,8.18-15.24l8.06-15.32,8-15.38q4-7.71,7.83-15.46-4.12,7.59-8.18,15.24l-8.06,15.31-7.95,15.39Q342,449.55,338.08,457.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.08,395.9q3.89,7.75,7.84,15.46l7.95,15.38,8.06,15.32q4.05,7.65,8.18,15.24-3.87-7.76-7.83-15.46l-8-15.39-8.06-15.31Q342.21,403.49,338.08,395.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.52,47v170.1H436.58V47ZM432.26,212.73H323.84V51.27H432.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.84,
    y: 51.27,
    width: 108.42,
    height: 161.46,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.84,
    y: 134.84,
    width: 108.42,
    height: 4.32,
    transform: "translate(756.1 274) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.57,
    y: 217.05,
    width: 132.97,
    height: 12.4,
    transform: "translate(756.1 446.49) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.09 234.4 441.01 237.04 441.01 229.44 315.09 229.44 315.09 234.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.84,51.27H432.26V162.2H323.84Zm104.42,4H327.84V158.2H428.26Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.5,
    y: 51.27,
    width: 2.16,
    height: 106.93,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.44,
    y: 51.27,
    width: 2.16,
    height: 106.93,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.42,47v170.1H180.48V47ZM176.16,212.73H67.74V51.27H176.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.74,
    y: 51.27,
    width: 108.42,
    height: 161.46,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.74,
    y: 134.84,
    width: 108.42,
    height: 4.32,
    transform: "translate(243.9 274) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.47,
    y: 217.05,
    width: 132.97,
    height: 12.4,
    transform: "translate(243.9 446.49) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.99 234.4 184.91 237.04 184.91 229.44 58.99 229.44 58.99 234.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74,51.27H176.16V162.2H67.74Zm104.42,4H71.74V158.2H172.16Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.4,
    y: 51.27,
    width: 2.16,
    height: 106.93,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.34,
    y: 51.27,
    width: 2.16,
    height: 106.93,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-112"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.03,
    y: 379.05,
    width: 99.68,
    height: 82.36,
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.03,
    y: 379.05,
    width: 99.68,
    height: 82.36,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.71,
    y: 379.06,
    width: 39.5,
    height: 82.36,
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.71,
    y: 379.06,
    width: 39.5,
    height: 82.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.48,455.74q-4.38-8.78-8.69-17.62l-8.57-17.72-8.46-17.79q-4.2-8.91-8.33-17.88,4.4,8.79,8.7,17.62l8.56,17.72,8.46,17.79Q371.37,446.77,375.48,455.74Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.48,384.73q-4.12,9-8.33,17.88l-8.46,17.79-8.56,17.72q-4.31,8.83-8.7,17.62,4.13-9,8.33-17.88l8.46-17.79,8.57-17.71Q371.1,393.51,375.48,384.73Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.92 396.85 294.35 396.85 293.16 396.85 292.49 395.48 291.54 396.85 290.25 394.03 289.04 396.85 285.56 396.85 283.97 396.85 283.39 394.97 282.85 396.85 281.82 396.85 281.82 379.06 295.92 379.06 295.92 396.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.35,
    y: 296.7,
    width: 74.37,
    height: 82.35,
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.72,
    y: 296.7,
    width: 38.4,
    height: 82.36,
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.72,
    y: 296.7,
    width: 38.4,
    height: 82.36,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.27,373.38q-8.19-8.79-16.24-17.62L307,338l-15.79-17.79q-7.86-8.91-15.56-17.88,8.2,8.79,16.24,17.63l16,17.71,15.79,17.79Q331.57,364.41,339.27,373.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.27,302.37q-7.71,9-15.56,17.88L307.92,338l-16,17.72q-8,8.83-16.24,17.62,7.71-9,15.56-17.88L307,337.71,323,320Q331.07,311.15,339.27,302.37Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 370.99,
    y: 365.12,
    width: 6.73,
    height: 9.5,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-112"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "41.45 461.45 93.59 461.2 145.73 461.12 250 460.95 354.27 461.12 406.41 461.2 458.55 461.45 406.41 461.69 354.27 461.78 250 461.95 145.73 461.78 93.59 461.69 41.45 461.45",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fly--inject-112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.72,177.8q-.84-.54-1.68-1.05l.39-.65,1.7,1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3,278h-.72l0-.75a33.51,33.51,0,0,0,4-.15l.08.75C267.57,277.93,266.43,278,265.3,278Zm7.42-.82-.16-.73a26.84,26.84,0,0,0,3.82-1.17l.27.7A27.59,27.59,0,0,1,272.72,277.16Zm7.63-3-.37-.65a24.82,24.82,0,0,0,3.27-2.28l.48.57A24.65,24.65,0,0,1,280.35,274.19Zm6.33-5.2-.55-.51a27.9,27.9,0,0,0,2.47-3.14l.62.42A28.34,28.34,0,0,1,286.68,269Zm4.58-6.79-.68-.32a23.16,23.16,0,0,0,1.39-3.74l.72.2A23.68,23.68,0,0,1,291.26,262.2Zm2.16-7.92-.75-.06c0-.54.07-1.09.07-1.62a20.36,20.36,0,0,0-.13-2.22,20.42,20.42,0,0,1-2.32-.29l.13-.74a21.4,21.4,0,0,0,3.7.34h.26v.75h-.27l-.75,0a19.77,19.77,0,0,1,.12,2.18C293.49,253.15,293.46,253.72,293.42,254.28Zm5.07-4.34-.17-.73a16.66,16.66,0,0,0,3.71-1.36l.34.67A17.49,17.49,0,0,1,298.49,249.94ZM286.31,249a25.91,25.91,0,0,1-3.75-1.7l.37-.65a24.82,24.82,0,0,0,3.63,1.64Zm5.38-2.64a17.8,17.8,0,0,0-1.72-3.57l.63-.4a18,18,0,0,1,1.8,3.72Zm14.12-.16-.48-.57a20.27,20.27,0,0,0,2.77-2.85l.58.47A20.6,20.6,0,0,1,305.81,246.23ZM279.17,245l-.21-.2a9.06,9.06,0,0,1-2.31-3.15l.7-.28a8.25,8.25,0,0,0,2.12,2.88l.2.18ZM311,239.89l-.64-.39c.7-1.16,1.35-2.35,1.92-3.52l.68.33C312.38,237.5,311.72,238.71,311,239.89Zm-23.52-.15a17.83,17.83,0,0,0-3-2.34l-.15-.1.39-.64.16.1a18.4,18.4,0,0,1,3.09,2.45Zm-9.93-1.93-.62-.42a4.57,4.57,0,0,1,3.78-1.92l0,.75A3.89,3.89,0,0,0,277.55,237.81Zm37-5.27-.7-.26a38.42,38.42,0,0,0,1.19-3.83l.72.18A34.56,34.56,0,0,1,314.56,232.54Zm2-7.93-.75-.1a35.54,35.54,0,0,0,.31-4h.75A37,37,0,0,1,316.55,224.61Zm-.58-8.1a38.72,38.72,0,0,0-.57-4l.74-.15a40.7,40.7,0,0,1,.58,4.05Zm-1.55-7.86c-.38-1.26-.83-2.53-1.35-3.79l.7-.28c.52,1.27,1,2.57,1.37,3.85Zm-3-7.45c-.6-1.17-1.27-2.35-2-3.51l.64-.39c.72,1.17,1.4,2.37,2,3.56Zm-4.21-6.86c-.77-1.08-1.6-2.15-2.46-3.19l.58-.48c.87,1.05,1.71,2.14,2.49,3.23Zm-5.12-6.22c-.91-1-1.87-1.93-2.85-2.85l.51-.55c1,.94,2,1.91,2.88,2.89Zm-5.87-5.53c-1-.85-2.09-1.69-3.16-2.49l.44-.6c1.09.8,2.17,1.65,3.2,2.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.39,277.64a18.66,18.66,0,0,1-2-.36l.18-.73s.72.18,1.92.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,276.15c-.47,4,7.7,6.24,8.32,1S250.77,272.12,250.3,276.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,282.77c-.76,1.51-3.45,1.72-6.23-.22a18.65,18.65,0,0,1-4.7-5.27,18.53,18.53,0,0,1,7,.61C260.36,279,261.8,281.24,261,282.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1,277.28c1.58.71,3.13,1.48,4.68,2.24s3.08,1.57,4.59,2.41c-1.58-.71-3.13-1.48-4.68-2.24S251.61,278.12,250.1,277.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.36,282.74a13.85,13.85,0,0,1-1-1.31,13.26,13.26,0,0,1-.82-1.41,13.85,13.85,0,0,1,1,1.31A12.33,12.33,0,0,1,257.36,282.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,279.23a15.94,15.94,0,0,1,1.67-.34,16.21,16.21,0,0,1,1.71-.15,17.09,17.09,0,0,1-3.38.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13,279.89a3.75,3.75,0,0,1-.72-1.46,3.75,3.75,0,0,1,.72,1.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.32,272.3c-.39-1.65-2.95-2.47-6.1-1.23a18.66,18.66,0,0,0-5.8,4.05,18.58,18.58,0,0,0,7,1C260.79,275.84,262.72,274,262.32,272.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.42,275.12c1.7-.32,3.39-.72,5.07-1.11s3.36-.81,5-1.28c-1.69.32-3.38.72-5.06,1.11S252.09,274.65,250.42,275.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.75,271.48a14.16,14.16,0,0,0-1.25,1,15.74,15.74,0,0,0-1.13,1.18,11.39,11.39,0,0,0,1.25-1A14,14,0,0,0,258.75,271.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65,274.12a16.25,16.25,0,0,0,3.18,1.25,15.61,15.61,0,0,0-3.18-1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,273.28a3.49,3.49,0,0,0-.59.56,4.1,4.1,0,0,0-.45.69,3.54,3.54,0,0,0,.59-.57A2.87,2.87,0,0,0,254,273.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,276.15a1.46,1.46,0,1,1-1.62,1.29A1.47,1.47,0,0,1,250.3,276.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.64,273.24a1.46,1.46,0,1,1-.34,2.91,1.46,1.46,0,0,1,.34-2.91Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,370.31S138.68,413,138.67,413c-1.76,8.81-3.14,16.58-3.49,20.66a.16.16,0,0,0,0,.07,6.22,6.22,0,0,0,.11,2.85.16.16,0,0,0,0,.07c2.27,2.3,72.33,18.43,75,18.17s2.1-7.79-.12-10.58-26.29-21-26.29-21l20.84-42.76Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.23,454.86c-2.63.26-71.64-15.88-73.9-18.17a.25.25,0,0,1,0-.07,6.18,6.18,0,0,1-.12-2.85.1.1,0,0,1,0-.07c.34-4.08,1.73-11.85,3.48-20.67l5.1-10.22L188,414.93l-4.08,8.38s23,18.17,25.23,21S211.87,454.61,209.23,454.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.19,453.74c-2.67.2-72.9-17.7-75.14-20.08-.86-.89,1.15-11.28,3.94-23.76l.09-.39,45.44,11.05-.21.76s23.81,18.88,26,21.76S212.85,453.55,210.19,453.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.08,450.81c-11.76-3.3-59.52-15.54-71.4-17.92-.1,0-.12.05,0,.08,11.59,3.53,59.45,15.38,71.38,18C210.29,451.06,210.33,450.88,210.08,450.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.08,422.43c-4.44-2.06-10.32-2.8-14.72-.38-.17.09,0,.33.12.32a67.66,67.66,0,0,1,14.43.64A.31.31,0,0,0,188.08,422.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,425.31c-4.43-2.05-10.31-2.79-14.72-.38-.17.09,0,.33.13.33a67,67,0,0,1,14.43.64A.31.31,0,0,0,190.92,425.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.77,428.2c-4.44-2.06-10.32-2.8-14.72-.39-.17.1,0,.34.13.33a67.6,67.6,0,0,1,14.42.64A.31.31,0,0,0,193.77,428.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.9,451.5c1.13.8-.22,4.95-1.21,5.06S133.21,436.81,132,436.18s.45-5.17,2-5S211.9,451.5,211.9,451.5Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.67,420.33c-4.44-3.84-10.42,3.06-6,6.91S153.12,424.18,148.67,420.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.92,399.4l51.24,12.92s47.76-86.19,46.69-108.1C240.38,274,204.9,181.08,204.9,181.08H162.42S190.61,281.53,191,298.43C191.17,307.27,143.92,399.4,143.92,399.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.35,401.92c-2.73-1.09-27.12-8.13-45.32-12a.1.1,0,0,0,0,.19c5.73,2,41.89,11.53,45.28,12C197.39,402.14,197.47,402,197.35,401.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.52,276.85c-3.38-14.18-7-28.32-10.8-42.37s-7.87-28.23-12.34-42.17c-.54-1.71-1.11-3.4-1.66-5.1a.21.21,0,0,0-.41.12c4,13.89,8,27.75,11.79,41.69s7.4,27.92,10.8,42c.85,3.48,1.68,6.95,2.49,10.44a93.34,93.34,0,0,1,2.18,10.87,28.15,28.15,0,0,1-.71,10.46,58.73,58.73,0,0,1-3.77,9.74q-9.19,19.95-18.37,39.91c-6.12,13.34-7.11,16.38-13,29.83-.73,1.67-1.46,3.34-2.16,5,0,.11.11.21.17.09,6.7-13.18,7.73-16.35,14-29.77s12.5-27,18.72-40.51c2.8-6.1,6.09-12.32,6.51-19.14C198.38,290.82,196.14,283.68,194.52,276.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.84,387.19s1.64,47,1.64,47c.27,9,.66,16.87,1.25,20.92a.17.17,0,0,0,0,.07,6.3,6.3,0,0,0,.74,2.75l.06.06c2.73,1.73,74.62,1.69,77.13.84s.29-8.05-2.5-10.28-30.33-14.52-30.33-14.52l-2.09-46.95Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.14,424.57s.34,9.62.34,9.65c.27,9,.66,16.87,1.25,20.92a.17.17,0,0,0,0,.07,12,12,0,0,0,.74,2.75l.06.06c2.73,1.73,74.62,1.69,77.13.84s.29-8.05-2.5-10.28-30.33-14.52-30.33-14.52l-.21-9.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.7,458.78c-2.54.81-75-.31-77.74-2.11-1-.67-1.5-11.23-1.68-24v-.4l46.76.2,0,.8s27.55,12.83,30.34,15.12S280.25,458,277.7,458.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.93,456c-12.21-.49-61.51-1.31-73.62-.86-.1,0-.1.07,0,.07,12.09.75,61.4,1.18,73.62,1C277.18,456.15,277.19,456,276.93,456Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94,433.45c-4.79-1-10.69-.33-14.41,3-.15.13,0,.33.2.29a68.23,68.23,0,0,1,14.18-2.73A.3.3,0,0,0,248.94,433.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.38,435.59c-4.8-1-10.69-.32-14.41,3.05-.15.13,0,.33.19.28a67.65,67.65,0,0,1,14.19-2.72A.31.31,0,0,0,252.38,435.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.81,437.74c-4.79-1-10.68-.33-14.41,3-.14.13,0,.33.2.29a68.35,68.35,0,0,1,14.18-2.73A.3.3,0,0,0,255.81,437.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.85,456.2c1.29.52.94,4.87,0,5.2s-80-1.24-81.29-1.56-.77-5.13.8-5.36S278.85,456.2,278.85,456.2Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.12,440.55c-5.21-2.71-9.43,5.39-4.21,8.1S215.34,443.26,210.12,440.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.37,181a.16.16,0,0,1,0,0c-.19.87-10.78,42.74-12.1,43.52-1.5.89,38.48,54.68,43.22,81.09,3,16.89,10,115.34,10,115.34H194.51s-5-83.61-6.66-111.16c-.65-10.69-40.75-60.11-44.56-93.06-1.2-10.38,6.26-35.77,6.26-35.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.22,381.17c-.6-13.85-1.15-27.73-2.16-41.56-.57-7.84-1.69-15.43-2.47-23.24,0-.41-.37-.51-.36-.09.36,13.91,1.51,27.67,2.25,41.57s1.45,17.14,2.24,31c.44,7.84.83,15.68,1.44,23.51a.1.1,0,0,0,.19,0C194.38,398.44,193.83,395.07,193.22,381.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.54,306.27a74,74,0,0,0-2.12-10.83,55.4,55.4,0,0,0-4.13-9.95c-3.47-6.66-7.42-13.1-11.23-19.57s-7.78-13.08-11.8-19.54q-3.39-5.44-6.81-10.87c-2.32-3.65-4.77-7.23-7.16-10.83a.13.13,0,0,0-.23.14c3.9,6.54,7.76,13.09,11.66,19.63s7.74,13.1,11.58,19.66,7.57,12.92,11.19,19.48a68.44,68.44,0,0,1,4.59,9.72A59.67,59.67,0,0,1,233.65,304c1.36,8.47,2.47,17,4.17,25.39a.1.1,0,0,0,.19,0C237.48,321.67,236.56,313.94,235.54,306.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,412.21c-2.91-.38-25.12-1.15-43.7-.35-.12,0-.11.18,0,.19,6.05.53,40.26.77,43.67.37C241.06,412.41,241.1,412.23,241,412.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.92,221.66a95,95,0,0,0-15,7,.17.17,0,0,0,.14.31c5.06-2.18,10.23-4.26,15.17-6.71A.33.33,0,0,0,198.92,221.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.45,187c0-.17-.32-.21-.32,0a168.24,168.24,0,0,1-.85,16.92c-.24,2.61-2.34,17-6.86,16-.76-.18-1.14-.92-1.26-2.07a17.68,17.68,0,0,1,.6-4.42c.5-3,.9-6,1.16-9.09a82.44,82.44,0,0,0-.18-17.06.15.15,0,0,0-.29,0,156.94,156.94,0,0,1-1.38,23.54c-.57,3.75-2.46,9.4,1.47,10s6.58-8.87,7.06-11.46A86.44,86.44,0,0,0,200.45,187Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.54,220.23a23.39,23.39,0,0,0-1,3,6.87,6.87,0,0,0-.42,2.45.17.17,0,0,0,.31.07,8.4,8.4,0,0,0,1.05-2.39c.35-.93.71-1.84,1-2.78A.5.5,0,0,0,192.54,220.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.67,323.23c-.48-7.12-.45-14.63-3.48-21.23a70.82,70.82,0,0,0-5.54-9.24q-3.1-4.74-6.12-9.53c-8-12.77-15.72-25.8-22.75-39.15-3.39-6.43-6.51-13.07-8.21-20.17a64.5,64.5,0,0,1-.93-22.76c.24-1.89.5-3.77.81-5.65a.11.11,0,0,0-.21-.05,74.51,74.51,0,0,0-1.67,22,61.38,61.38,0,0,0,5.87,20.29c3.1,6.71,6.79,13.17,10.43,19.6q5.63,10,11.59,19.71c4,6.46,8.12,12.79,12.25,19.15a36.43,36.43,0,0,1,4.87,9.79,53.41,53.41,0,0,1,1.56,11.12c1,15.74,5,68.07,6.42,83.73.17,2,.35,4,.54,6a.14.14,0,1,0,.27,0C199.77,391.12,195.7,338.92,194.67,323.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,194.8c0-.11-.18-.07-.18,0-.15,4.37,0,8.89-1.71,13-1.54,3.79-4.64,6.45-8.11,8.44a61.89,61.89,0,0,1-6.23,3.05c-.15.07-.09.31.08.26,4-1.28,8.13-2.67,11.48-5.35,3.58-2.88,5.15-7.05,5.32-11.55A37.26,37.26,0,0,0,170.2,194.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.39,123.57c5.72,17.56,21.17,47.47,26.69,51.08,4.89,3.19,27.9-.37,38-2.8,3.76-.91-4.7-29.57-8.71-28.52-4.81,1.26-19.14,4.49-20.18,3.69s-15.49-18.6-25.73-29.08C193.14,108.45,190.23,116.93,192.39,123.57Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.87,172.07c1.93-.24,18.26-1,25.75-5.07,4-2.17,14.21-9.35,13.19-11.93-.93-2.35-4.21-1.07-4.21-1.07s4.51-3.27,3.19-6.53-6.77-.81-6.77-.81,4.39-3.7,2.84-6.85-6.61.22-6.61.22,4.17-3.19,1.8-5.25c-2.86-2.48-9.89,4.28-14.64,5.86-1.08.36-22.36,5.74-22.36,5.74Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.07,139.94c-5.18,4.95-8.31,6.22-15.23,7.62-.13,0-.12.24,0,.22,6.9-.75,11.05-1.78,15.46-7.6C282.54,139.89,282.31,139.7,282.07,139.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.85,146.54c-5.83,4.68-9.21,6.08-16.35,8.08-.1,0-.06.21.05.19,7.16-1.38,11.28-2.5,16.49-7.94C286.28,146.63,286.12,146.33,285.85,146.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.25,154.08c-6,4.12-9.61,5.83-16.79,6.88a.13.13,0,0,0,0,.26c7.43-.36,12-2.45,16.87-6.94C289.69,154,289.62,153.83,289.25,154.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.47,147.3s5.95-6.73,9.21-9.11,18.7-6.78,19.84-3.5c1.47,4.24-6.94,8.53-11.33,10.09,0,0,3.41,9.8-2,14.18S241.47,147.3,241.47,147.3Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.55,136c-1.45,4.83-7.35,6.51-11.5,8.34a.43.43,0,0,0-.16.67c1.16,4.2,1.56,10.46-1.38,14-.08.1.05.24.15.15,3.67-3.36,3.77-9.55,2.21-14.07,4.29-1.81,10.13-3.76,10.72-9.07C270.6,136,270.56,136,270.55,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.86,177l-7.54-34.34-18.66,3.39c-7.36-8.43-22.07-25.28-28-30.34-7-5.94-11.58-1.48-9,7.52C197.49,143.8,214.54,174,219,176.85,225.47,181,254.86,177,254.86,177Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,156.5a14.58,14.58,0,0,0,2.81.33c2,.27,2.88,3.22,1.06,4.34a7.18,7.18,0,0,1-6.44.55c-2-.78-3.69-2.72-3.26-5a2.5,2.5,0,0,1,4-1.54A9.3,9.3,0,0,0,228.22,156.5Zm-5.16-8.17c-.72,3.4,4.54,6.32,7.23,4.51a1.81,1.81,0,0,0,.07-2.83c-.79-.64-1.45-.74-2.15-1.32a3.2,3.2,0,0,1-.64-.67,4.79,4.79,0,0,0-1.49-1.34A2.19,2.19,0,0,0,223.06,148.33Zm-8.39.18c-1.08,1.41-.27,3.53.68,4.81a4.34,4.34,0,0,0,3.93,1.91,1.46,1.46,0,0,0,.74-2.56,4.64,4.64,0,0,1-1.4-1.74c-.47-1.06-.78-2.43-2-2.89A1.71,1.71,0,0,0,214.67,148.51Zm22.15,22.24c-1.41,2.85,2.88,6.09,5.48,5.53.87-.19,1.71-1.33.94-2.15-.62-.66-1.36-1.18-1.94-1.88-.71-.85-1.1-1.94-2.21-2.37A1.76,1.76,0,0,0,236.82,170.75ZM196.54,135.8a3.82,3.82,0,0,0-1-1.21q.84,2.15,1.77,4.31A5.9,5.9,0,0,0,196.54,135.8Zm5.57-3a11.85,11.85,0,0,0-2.76-6.71c-1.2-1.55-3.28-4-5.48-3.47a1.14,1.14,0,0,0-.8,1.1c-.14,1.69,1.8,3.5,2.64,4.85,1,1.7,1.79,3.58,2.87,5.27A1.92,1.92,0,0,0,202.11,132.79Zm-.65,10.75a1.83,1.83,0,0,0,1.68-1.38,4.51,4.51,0,0,0-.15-2.33,3.91,3.91,0,0,0-1-1.9,1.42,1.42,0,0,0-2.34.69,6.48,6.48,0,0,0,0,1.76c0,.25,0,.5,0,.76a4.69,4.69,0,0,0,.12,1.12A1.77,1.77,0,0,0,201.46,143.54Z",
    style: {
      fill: "#030402",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.33,174c-.86-2-3-10.88-3.47-13.09s-2.21-11.15-2.72-13.42c0-.13.14-.2.17-.08.54,2.24,2.95,11.06,3.48,13.26s2.52,11.07,2.66,13.3A.06.06,0,0,1,248.33,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,178.72c-5.25,0-9.86-.5-12-1.87-4.49-2.9-21.54-33-27.41-53.61-1.48-5.16-.59-8.84,1.75-9.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.38,185.71c.13.19,62.53,8.19,63.2,7.61a45.24,45.24,0,0,0,.75-5.26s-5.72-67.94-8.68-71.93c-2.59-3.48-10.45-6-15.8-3.73-11.23,4.76-38.12,65.46-37.83,68C148,180.37,146.22,185.47,146.38,185.71Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.88,177.44a16.92,16.92,0,0,0,3,1.12c2.08.83,2.27,4.3,0,5a8.12,8.12,0,0,1-7.2-1.15c-2-1.4-3.29-4-2.21-6.32a2.82,2.82,0,0,1,4.78-.6C167.81,176.14,168.15,177,168.88,177.44Zm-3.42-10.33c-1.71,3.53,3.24,8.14,6.67,6.89a2,2,0,0,0,.84-3.08c-.68-.91-1.38-1.2-2-2a3.54,3.54,0,0,1-.51-.91,5.71,5.71,0,0,0-1.27-1.86C168,165,166.09,165.81,165.46,167.11Zm-5.78-3.76c-1.87.7-2.35,3.22-2.21,5a4.89,4.89,0,0,0,2.62,4.17,1.64,1.64,0,0,0,2.23-2A5.1,5.1,0,0,1,162,168c.17-1.28.68-2.78-.17-3.93A1.93,1.93,0,0,0,159.68,163.35Zm20.5,11.9a1.86,1.86,0,0,0-2,1.59,2.18,2.18,0,0,0,1.55,2.31,3.35,3.35,0,0,0,2.1,0,1.56,1.56,0,0,0,.81-.73,1.62,1.62,0,0,0,.23-1.08,1.75,1.75,0,0,0-1.37-1.44,1.14,1.14,0,0,0-.22-.22A2.08,2.08,0,0,0,180.18,175.25Zm-15.33-24.13c-1.68,1.72-1,5.63.92,6.95a1.78,1.78,0,0,0,2.84-1.17,8,8,0,0,0,0-1.19c0-.43-.06-.7,0-1a9.39,9.39,0,0,0,.09-2.59A2.2,2.2,0,0,0,164.85,151.12ZM154,176c-2.31,2.74,1.5,7.44,4.49,7.53,1,0,2.23-1,1.61-2.1-.5-.88-1.17-1.66-1.61-2.57-.54-1.12-.67-2.43-1.77-3.19A2,2,0,0,0,154,176Zm55.17-.87a1.92,1.92,0,0,0-1.58,1.44c-.32,1.11-.36,2.1-1.19,3A13.69,13.69,0,0,0,204,182a1.47,1.47,0,0,0,1.34,2.14,6.91,6.91,0,0,0,4.47-2.44C209.61,179.8,209.41,177.57,209.18,175.09Zm-5-8.25c-.56,1.36-.46,2.9-.93,4.32a33.85,33.85,0,0,1-1.47,3.82c-.42.9.42,2.32,1.51,1.84a7.53,7.53,0,0,0,4.06-3.71c.76-1.57,1.6-4.21.87-5.88S205,164.87,204.15,166.84Zm-5.7,13.63a9,9,0,0,1-3.11,2.55,2.14,2.14,0,1,0,1.75,3.87,7.7,7.7,0,0,0,4.34-4.86C201.92,180.34,199.58,179.21,198.45,180.47Zm-9.14-49a2.21,2.21,0,0,0,2.6-1.62c.56-2.15-1.36-4.36-2.88-5.7s-3.66-2.56-5.79-1.87a1.75,1.75,0,0,0-.71,2.89c.93,1.16,2.22,2,3.21,3.14S187.57,131.18,189.31,131.47ZM197,140c.84-1.21.19-3-.41-4.15a3.67,3.67,0,0,0-1.43-1.52,1.86,1.86,0,0,0-2.56.55,2.45,2.45,0,0,0-.12,1.82,5,5,0,0,0,.34.91l0,.09,0,.08A6.09,6.09,0,0,0,194,140.4,1.9,1.9,0,0,0,197,140Zm5.16-7.16a11.85,11.85,0,0,0-2.76-6.71c-1.2-1.55-3.28-4-5.48-3.47a1.14,1.14,0,0,0-.8,1.1c-.14,1.69,1.8,3.5,2.64,4.85,1,1.7,1.79,3.58,2.87,5.27A1.92,1.92,0,0,0,202.11,132.79Zm-7.55,17.12a2.6,2.6,0,0,0,1.11,0,2.28,2.28,0,0,0,1.31-1.05,3.69,3.69,0,0,0,.39-1.73,3.55,3.55,0,0,0-.45-1.62l-.33-.41-.44-.32a2.06,2.06,0,0,0-2.94,1.32,10.78,10.78,0,0,0-.35,1.78l.09.55a1.72,1.72,0,0,0,.4.74A2.14,2.14,0,0,0,194.56,149.91Zm6.9-6.37a1.83,1.83,0,0,0,1.68-1.38,4.51,4.51,0,0,0-.15-2.33,3.91,3.91,0,0,0-1-1.9,1.42,1.42,0,0,0-2.34.69,6.48,6.48,0,0,0,0,1.76c0,.25,0,.5,0,.76a4.69,4.69,0,0,0,.12,1.12A1.77,1.77,0,0,0,201.46,143.54Z",
    style: {
      fill: "#030402",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,126.78c-3.81-.35-8.69-8.49-9.62-13.66-.06-.36,1.46-3.37,3.13-7.11,1-2.27,2.08-4.83,2.88-7.23l13.84,8.71a40.42,40.42,0,0,0-4.55,8.74,5.66,5.66,0,0,0-.22,1,1.36,1.36,0,0,1,0,.17C203.11,119.4,201.69,127.12,198,126.78Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,117.25a1.55,1.55,0,0,1,0,.17,11,11,0,0,1-1.57-.43c-8.66-3.12-7.13-14.48-6.52-17.62l3.45,2.18,9.45,6a40.11,40.11,0,0,0-4.54,8.74A5.47,5.47,0,0,0,203.46,117.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.84,82.75c-2.86,5.15-3.36,21.69-.19,26.08,4.58,6.36,13.78,8.84,19.61,3,5.65-5.72,5.91-27.29,2.23-31.45C212.05,74.2,200.06,75.14,195.84,82.75Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.12,96.12s-.09,0-.09.1c0,1.14-.2,2.44-1.24,2.78,0,0,0,.07,0,.07C209.06,98.93,209.3,97.2,209.12,96.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.15,94.9c-1.83-.2-2.1,3.46-.41,3.65S209.68,95.07,208.15,94.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.68,96.51s.08.06.08.11c-.13,1.13-.08,2.45.91,2.9,0,0,0,.08,0,.07C215.42,99.31,215.38,97.56,215.68,96.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.79,95.41c1.83,0,1.68,3.67,0,3.67S215.25,95.4,216.79,95.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.63,94.16c-.51.11-1,.12-1.5.18a2.44,2.44,0,0,1-1.56-.11.78.78,0,0,1-.31-.9,1.93,1.93,0,0,1,1.66-1,2.76,2.76,0,0,1,2,.38A.82.82,0,0,1,209.63,94.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.43,92a13.37,13.37,0,0,1-1.43-.49,2.42,2.42,0,0,1-1.36-.77.77.77,0,0,1,.11-.94,1.9,1.9,0,0,1,1.94-.22,2.85,2.85,0,0,1,1.64,1.2A.83.83,0,0,1,218.43,92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.29,105.14a9.62,9.62,0,0,1,4.48,0c.13,0,.26-.26.29-.38h0s.08-2.4.08-2.4c.31.18,1.87,1,1.87.56a57.07,57.07,0,0,0-.71-11.66.11.11,0,0,0-.21,0c-.16,3.61.3,7.21.19,10.84a6.64,6.64,0,0,0-1.76-.67c-.13,0,0,2.55,0,2.93a5.58,5.58,0,0,0-4.2.23C207.8,104.92,207.59,105.36,208.29,105.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.33,107.52c.25.28.5.66.9.72a2.9,2.9,0,0,0,1.23-.21s.07,0,0,.06a1.49,1.49,0,0,1-1.46.52,1.19,1.19,0,0,1-.82-1C205.2,107.5,205.29,107.48,205.33,107.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.67,77.5c-.15,2.57-.76,10.54-2,12.16s-3.86,5.39-5.19,6c.18-5.31,1-10.36,2.37-13A13.57,13.57,0,0,1,200.67,77.5Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.92,85.29a5.84,5.84,0,0,1-5.47,1.6A5.93,5.93,0,0,1,205.12,83c0-.06-.11,0-.09,0a5.87,5.87,0,0,0,4.3,4.31,6,6,0,0,0,5.69-2C215.08,85.32,215,85.23,214.92,85.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,70.47a9.18,9.18,0,0,0-8,3.7,6.57,6.57,0,0,0-.94,4.22s.13,0,.13,0a7.17,7.17,0,0,1,3.85-6.25,9.3,9.3,0,0,1,8.26-.41,5.92,5.92,0,0,1,3,2.75c.06.13.32.07.27-.06C215.65,72.24,213,70.62,209.9,70.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,79.19A7.4,7.4,0,0,0,226.12,75c-2-1.43-4.34-1.41-6.68-1.33-.07,0-.06.1,0,.09a10.38,10.38,0,0,1,5.78,1.07,7.34,7.34,0,0,1,3.13,3.81,7.15,7.15,0,0,1-3.59,8.66,7.26,7.26,0,0,1-5.76.18c-.07,0-.13.07-.06.11A7.31,7.31,0,0,0,229,79.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.84,86s-2.76-6.29.19-9.59c1.67-1.86,6.69-1.22,6.69-1.22a9.14,9.14,0,0,1,6.1-3.42C212.11,71.1,217,74,217,74s4.18-2,7.77.43c5,3.39,3.75,11.32-1.71,13.48-3.84,1.53-8.62-2.13-8.62-2.13-.48,0-5.66,2.64-9.07-2.06,0,0-3.24,2.47-5.83.37A4.42,4.42,0,0,1,194.84,86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.47,96.45s-2.62-5.87-5.21-5-1.33,8.85,1.23,10.41a2.84,2.84,0,0,0,4-.78Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.68,93.71a0,0,0,0,0,0,.07c1.78,1.15,2.45,3.14,2.8,5.13a1.57,1.57,0,0,0-2.23-.86c-.06,0,0,.11,0,.11a1.74,1.74,0,0,1,1.78,1,7.86,7.86,0,0,1,.62,1.7c0,.19.38.16.36,0v0C195.52,98.28,194.27,94.47,191.68,93.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.65,
    y: 123.14,
    width: 112.6,
    height: 66.28,
    transform: "translate(-33.01 92.06) rotate(-17.03)",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.65,
    y: 123.14,
    width: 112.6,
    height: 66.28,
    transform: "translate(-33.01 92.06) rotate(-17.03)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.77,
    y: 112.19,
    width: 37.84,
    height: 66.28,
    transform: "translate(-28.24 102.05) rotate(-17.03)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.34,111.33q-1.83,8.42-3.56,16.84l-3.41,16.88L323.07,162q-1.62,8.46-3.16,16.95,1.83-8.41,3.56-16.84l3.41-16.88,3.3-16.91Q331.8,119.82,333.34,111.33Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.11,169.35q-6-6.16-12.11-12.27l-12.2-12.16-12.28-12.07q-6.16-6-12.38-12,6,6.17,12.11,12.27l12.2,12.16,12.28,12.07Q344.9,163.41,351.11,169.35Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.82,
    y: 140.63,
    width: 0.62,
    height: 8.71,
    transform: "translate(525.87 211.24) rotate(162.97)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.4,
    y: 141.06,
    width: 0.62,
    height: 8.71,
    transform: "translate(523.23 212.49) rotate(162.97)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.98,
    y: 141.5,
    width: 0.62,
    height: 8.71,
    transform: "translate(520.58 213.78) rotate(162.97)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.57,
    y: 141.93,
    width: 0.62,
    height: 8.71,
    transform: "translate(517.94 215.06) rotate(162.98)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.15,
    y: 142.36,
    width: 0.62,
    height: 8.71,
    transform: "translate(515.3 216.28) rotate(162.97)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.73,
    y: 142.8,
    width: 0.62,
    height: 8.71,
    transform: "translate(512.66 217.54) rotate(162.97)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.32,
    y: 143.23,
    width: 0.62,
    height: 8.71,
    transform: "translate(510.01 218.83) rotate(162.97)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.9,
    y: 143.67,
    width: 0.62,
    height: 8.71,
    transform: "translate(507.38 220.04) rotate(162.96)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.49,
    y: 144.1,
    width: 0.62,
    height: 8.71,
    transform: "translate(504.72 221.36) rotate(162.97)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.13,139.59l-2.46.06L255,138l-2.08,1.34.94,3.06c1.69-.29,2.83,1.12,3.69,3.92L252.22,148c-.86-2.79-.71-4.6.85-5.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.49 141.72 258.88 141.29 257.63 137.21 261.19 136.12 262.44 140.2 263.84 139.77 261.96 144.99 257.49 141.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.42 141.08 229.01 146.28 303.43 134 298.89 119.19 227.42 141.08",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.44 178.66 332.25 189.74 318.3 182.56 354.49 171.47 368.44 178.66",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.44 178.66 332.25 189.74 318.3 182.56 354.49 171.47 368.44 178.66",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.29 218.22 275.48 207.13 283.01 193.37 246.82 204.45 239.29 218.22",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.29 218.22 275.48 207.13 283.01 193.37 246.82 204.45 239.29 218.22",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.73,131.3c5.29,17.69,20,48,25.46,51.7,4.81,3.31,27.9.3,38-1.89,3.78-.81-4-29.67-8-28.72-4.84,1.15-19.25,4-20.27,3.21s-15-19-25-29.68C180.84,116.2,177.73,124.61,179.73,131.3Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.11,154.74s7.65-8.62,13.07-11.91a40.7,40.7,0,0,1,18.74-5.35c7.11-.28,24.5,3.94,24.15,9.16-.31,4.73-17.86-.49-17.86-.49s18.77,2.37,17.35,8-21.45-1.6-21.45-1.6S286.34,155.41,284,161c-1.8,4.21-20.31-1.31-20.31-1.31s16.52,2.58,14.85,7c-1.84,4.87-19.25.85-19.25.85-6.11,10.48-13.32,13-18.65,14.13C239.31,181.9,233.11,154.74,233.11,154.74Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,144.91c2.21.2,4.46.39,6.65.78s4.36.87,6.51,1.47a38.16,38.16,0,0,1,8.12,3.11c-4.75-2.05-12.57-3.59-14.76-4s-4.36-.9-6.54-1.29C264.69,145,264.71,144.91,264.77,144.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.2,152.8c2.81.37,5.63.64,8.43,1.14s5.39,1.22,8.14,1.91c.21.05.11.15-.1.1-2.78-.58-5.38-.9-8.16-1.44s-5.54-1.2-8.33-1.65C263.14,152.86,263.15,152.79,263.2,152.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.63,159.32a63.23,63.23,0,0,1,12.76,2.74c.21.06.07.17-.15.12-4.22-1-7.53-1.8-12.62-2.71C260.54,159.46,260.54,159.31,260.63,159.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.9,186.23l-6.72-34.52-18.73,2.94c-7.16-8.6-21.46-25.8-27.3-31-6.85-6.11-11.54-1.75-9.19,7.3,5.38,20.69,21.7,51.25,26.12,54.25C211.42,189.5,240.9,186.23,240.9,186.23Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,156.5a14.58,14.58,0,0,0,2.81.33c2,.27,2.88,3.22,1.06,4.34a7.18,7.18,0,0,1-6.44.55c-2-.78-3.69-2.72-3.26-5a2.5,2.5,0,0,1,4-1.54A9.3,9.3,0,0,0,228.22,156.5Zm-2-3.54a4.34,4.34,0,0,0,4-.12,1.5,1.5,0,0,0,.52-.6Zm-9.73,1.52a4,4,0,0,0,2.76.75,1.46,1.46,0,0,0,1.26-1.38Zm21.2,15.41a1.74,1.74,0,0,0-.9.86c-.84,1.69.33,3.51,2,4.6Zm-30.12,6.64c-.32,1.11-.36,2.1-1.19,3A13.69,13.69,0,0,0,204,182a1.47,1.47,0,0,0,1.34,2.14,7,7,0,0,0,6.14-7.22A2,2,0,0,0,207.6,176.53Zm-3.45-9.69c-.56,1.36-.46,2.9-.93,4.32a33.85,33.85,0,0,1-1.47,3.82c-.42.9.42,2.32,1.51,1.84a7.53,7.53,0,0,0,4.06-3.71c.76-1.57,1.6-4.21.87-5.88S205,164.87,204.15,166.84Zm-14.84-35.37a2.21,2.21,0,0,0,2.6-1.62c.56-2.15-1.36-4.36-2.88-5.7s-3.66-2.56-5.79-1.87a1.75,1.75,0,0,0-.71,2.89c.93,1.16,2.22,2,3.21,3.14S187.57,131.18,189.31,131.47ZM197,140c.84-1.21.19-3-.41-4.15a3.67,3.67,0,0,0-1.43-1.52,1.86,1.86,0,0,0-2.56.55,2.45,2.45,0,0,0-.12,1.82,5,5,0,0,0,.34.91l0,.09,0,.08A6.09,6.09,0,0,0,194,140.4,1.9,1.9,0,0,0,197,140Zm-2.39,10a2.6,2.6,0,0,0,1.11,0,2.28,2.28,0,0,0,1.31-1.05,3.69,3.69,0,0,0,.39-1.73,3.55,3.55,0,0,0-.45-1.62l-.33-.41-.44-.32a2.06,2.06,0,0,0-2.94,1.32,10.78,10.78,0,0,0-.35,1.78l.09.55a1.72,1.72,0,0,0,.4.74A2.14,2.14,0,0,0,194.56,149.91ZM203,139.85v0l-2-2.25a1.31,1.31,0,0,0-1.43,1,6.48,6.48,0,0,0,0,1.76c0,.25,0,.5,0,.76a4.69,4.69,0,0,0,.12,1.12,1.77,1.77,0,0,0,1.77,1.28,1.83,1.83,0,0,0,1.68-1.38A4.54,4.54,0,0,0,203,139.85Z",
    style: {
      fill: "#030402",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.44,183.06c-.81-2.05-2.71-10.95-3.16-13.18s-1.94-11.19-2.39-13.48c0-.12.14-.2.17-.07.48,2.25,2.69,11.12,3.16,13.34s2.26,11.12,2.34,13.36A.06.06,0,0,1,234.44,183.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.26,187.2c-3.07.18-6.14.25-9.21.23a74.78,74.78,0,0,1-9.22-.53,14.76,14.76,0,0,1-4.54-1.2,13.54,13.54,0,0,1-3.32-3.35,68.16,68.16,0,0,1-4.91-7.85c-3-5.39-5.58-11-8.1-16.58s-4.81-11.32-6.91-17.1c2.55,5.59,5.07,11.19,7.69,16.74s5.27,11.08,8.13,16.49a82.68,82.68,0,0,0,4.72,7.84,12.77,12.77,0,0,0,3,3.27,14.19,14.19,0,0,0,4.31,1.21A122,122,0,0,0,228.26,187.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,145.7a9.48,9.48,0,0,1-1.11-1.35,5.46,5.46,0,0,1-.77-1.57,8.31,8.31,0,0,0,.49.72l.49.71A14.72,14.72,0,0,1,184,145.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.79,136.43c2.53,2.54,4.8,5.33,7.15,8s4.6,5.49,7,8.15l.89,1c.16.15.31.32.46.46s.15.13.22.19,0,0,0,0,.07,0,.11,0c.76,0,1.72-.17,2.58-.28l5.32-.79c3.54-.52,7.09-1.06,10.64-1.54h0v0l.14.88-.21-.87.05,0c-3.51.75-7,1.42-10.56,2.07-1.77.32-3.54.6-5.32.87a24.74,24.74,0,0,1-2.75.32.86.86,0,0,1-.22,0,.82.82,0,0,1-.27-.14,3.74,3.74,0,0,1-.29-.25l-.49-.48c-.32-.33-.62-.66-.92-1-2.35-2.73-4.63-5.49-6.87-8.29l-3.35-4.21C202,139.21,201,137.77,199.79,136.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.1,136.73a10.05,10.05,0,0,1,1,1.48,5.61,5.61,0,0,1,.59,1.65c-.12-.27-.27-.51-.41-.77l-.41-.77A16.38,16.38,0,0,1,201.1,136.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.16,398.22a262.83,262.83,0,0,1,.39-28.07A356.81,356.81,0,0,1,90.34,313c2.45-10.58,5.47-21,8.62-31.38.09-.31.59-.22.51.1-9.73,36.64-17.72,74.46-17.17,112.54.16,10.66,1.39,21.13,2.4,31.72,0,.29-.44.4-.5.11C82.19,417,81.54,407.48,81.16,398.22Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.47,281.67s14.74,37.42,11.44,46.21-10.11,10.67-10.11,10.67,9,12.88,2.72,25-20.3,11.5-21.24,25.2C82.28,388.71,81.5,331.45,99.47,281.67Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.89,365.07a.28.28,0,0,1,0-.2A343,343,0,0,1,98.2,289.6c0-.07.14-.05.12,0q-4.38,16.41-7.74,33a16.28,16.28,0,0,1,7-3.92s.07,0,0,.07a18.72,18.72,0,0,0-7.26,4.86q-.64,3.24-1.25,6.51c3.29-3.68,7.86-5.51,12.43-7.25.06,0,.1.08,0,.1-4.76,1.94-9.51,4.44-12.73,8.54q-1.7,9.31-3,18.69a17.75,17.75,0,0,1,8.79-5c.1,0,.16.13,0,.16a18.59,18.59,0,0,0-8.91,5.71l-.06,0q-.44,3.3-.83,6.61A22.36,22.36,0,0,1,91.11,354c.06,0,.09.07,0,.09A21.41,21.41,0,0,0,85,358.18s0,0-.08,0c-.24,2.09-.49,4.19-.7,6.29a30,30,0,0,1,12.5-8.93.08.08,0,0,1,.06.15,32.58,32.58,0,0,0-12.32,9.48.27.27,0,0,1-.31.1c-.32,3.22-.61,6.45-.84,9.68,0,0-.08,0-.08,0C83.39,371.68,83.62,368.37,83.89,365.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.73,315a18.38,18.38,0,0,1,8.86-2.76c.07,0,.08.1,0,.11a34.85,34.85,0,0,0-8.76,2.86A.12.12,0,0,1,95.73,315Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.94,354.61a18.62,18.62,0,0,1,6.65-2.27c.08,0,.09.11,0,.12A25.25,25.25,0,0,0,94,354.77C93.93,354.81,93.85,354.66,93.94,354.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.41,328.49a100.21,100.21,0,0,1,17.06,14.92,61.17,61.17,0,0,1,12,20.29,152,152,0,0,1,8.91,48.53,117.46,117.46,0,0,1-2.63,27.29.26.26,0,0,1-.51-.09A153,153,0,0,0,77,391.72c-2.54-15.48-6.51-32.32-16.35-44.9C55.24,340,48.56,334.59,42,329,41.61,328.72,42.05,328.24,42.41,328.49Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.18,401.09a91.63,91.63,0,0,0-12.43-15.9c-7.38-7.37-13.59-12.61-14.55-17.49s7.39-8.46,7.39-8.46-10.21,1.83-13-2.46-4.14-29.08-4.14-29.08S60,341,68.67,359.53,78.18,401.09,78.18,401.09Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.87,334.06c7.82,7.67,15.68,15.84,20.28,25.92a101.19,101.19,0,0,1,4.1,10.69v0c.24.73.48,1.47.7,2.2a.19.19,0,0,1,0,.12,211.33,211.33,0,0,1,5.28,22.92c0,.05-.07.08-.08,0-.8-3.87-1.68-7.77-2.67-11.67l-.11,0A16.17,16.17,0,0,0,70.54,383c-.11,0-.1-.2,0-.2a18.38,18.38,0,0,1,4.82.88c-.9-3.51-1.88-7-3-10.47a52.32,52.32,0,0,0-11-1.44s0-.05,0-.06a41.8,41.8,0,0,1,10.82.92c-.19-.59-.39-1.18-.58-1.77a57.24,57.24,0,0,0-7.33-1.24c-.05,0,0-.08,0-.08a36,36,0,0,1,7.18.87q-1.52-4.49-3.32-8.8a53.3,53.3,0,0,0-3.5-6.81,44.53,44.53,0,0,0-5.94-1.06c-.06,0-.05-.09,0-.1a16.06,16.06,0,0,1,5.56.55q-1.47-2.37-3.1-4.62h0c-4.17-.92-8.39-1.77-12.65-1a.07.07,0,0,1,0-.13c4-1.07,8.07-.45,12.11.34-.44-.58-.89-1.16-1.35-1.73a27.26,27.26,0,0,0-7.78-1.23,0,0,0,1,1,0-.08,20.15,20.15,0,0,1,7.25.64c-3.44-4.28-7.24-8.29-11-12.26C47.55,334,47.69,333.87,47.87,334.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.08,351a16.89,16.89,0,0,1,3.69-.12c.15,0,.14.26,0,.26-1.22,0-2.44-.06-3.67,0C48,351.12,48,351,48.08,351Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.44,375a16.58,16.58,0,0,1,5.73,1.15s0,.09,0,.08c-1.89-.45-3.8-.64-5.71-.95C61.27,375.28,61.28,375,61.44,375Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.45,366.71a12.41,12.41,0,0,1,2.43.22c.08,0,.07.15,0,.15a12.3,12.3,0,0,1-2.43-.12A.13.13,0,0,1,65.45,366.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.6,354.82a84.4,84.4,0,0,0-17.25,8.12A51.83,51.83,0,0,0,101,376.6a128,128,0,0,0-18.43,37.22,99.53,99.53,0,0,0-4.18,22.69.22.22,0,0,0,.44,0A128.78,128.78,0,0,1,90,398c5.63-11.94,12.74-24.65,23.61-32.55,5.92-4.31,12.57-7.12,19.2-10.1C133.2,355.19,133,354.7,132.6,354.82Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.88,405.3a76.94,76.94,0,0,1,13.73-10c7.68-4.26,13.91-7.07,15.82-10.79s-4-8.56-4-8.56,7.83,3.84,11.08,1,10.07-22.59,10.07-22.59-18.08,6.44-29.38,19.48S86.88,405.3,86.88,405.3Z",
    style: {
      fill: "#FDE6C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.82,401.22c9-17,21.12-32.34,37.66-42.48,0,0,0,0,0,0a83.7,83.7,0,0,0-12.1,9.48,19.13,19.13,0,0,1,9.72,2c.07,0,0,.12,0,.1a26.68,26.68,0,0,0-10-1.69.25.25,0,0,1-.12,0c-.58.55-1.16,1.12-1.74,1.69a30.36,30.36,0,0,1,5.2.69s0,.08,0,.07a26.66,26.66,0,0,0-5.49-.45,110.87,110.87,0,0,0-8.53,9.69,8.56,8.56,0,0,1,3.63.26.07.07,0,0,1,0,.14,19.37,19.37,0,0,0-3.88-.06c-.49.63-1,1.26-1.48,1.9a34.74,34.74,0,0,1,11,1.07,0,0,0,1,1,0,.08,43.9,43.9,0,0,0-11.27-.73c-.46.61-.9,1.24-1.35,1.86a23.61,23.61,0,0,1,6.53.75c.09,0,.06.15,0,.13a24.83,24.83,0,0,0-6.77-.53q-2.91,4-5.6,8.2a6.06,6.06,0,0,1,2.87.17,0,0,0,0,1,0,.08,12.44,12.44,0,0,0-3.11.14q-2.42,3.76-4.66,7.59C88,401.61,87.7,401.45,87.82,401.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89,387.14a13.92,13.92,0,0,1,5.25.64s0,.09,0,.08a41.57,41.57,0,0,0-5.23-.54A.09.09,0,0,1,101.89,387.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.67,366.44a9.36,9.36,0,0,1,2.42.14.08.08,0,0,1,0,.15c-.79-.09-1.58-.06-2.38-.08A.11.11,0,0,1,117.67,366.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.55 461.45 104.37 461.45 98.55 418.8 97.06 407.87 70.86 407.87 69.37 418.8 63.55 461.45",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.37 418.8 98.55 418.8 97.06 407.87 70.86 407.87 69.37 418.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.11,
    y: 404.08,
    width: 33.71,
    height: 9.26,
    transform: "translate(167.92 817.41) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281,60.77A22.21,22.21,0,0,1,245.55,78.6l-10.89,2.78,4.53-10.13A22.22,22.22,0,1,1,281,60.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,60.76a22.46,22.46,0,0,1-3.28,11.68A25.69,25.69,0,0,1,276,75a24.82,24.82,0,0,1-2.13,2.22,21.75,21.75,0,0,1-5,3.53,22,22,0,0,1-5.8,2,21.11,21.11,0,0,1-3.07.38,18.75,18.75,0,0,1-3.09,0,22.53,22.53,0,0,1-11.52-4.25l.3.06-10.86,2.86-.88.23.37-.84,4.49-10.15,0,.42a22.47,22.47,0,0,1-.7-19.87,22.76,22.76,0,0,1,6.17-8.11,22.63,22.63,0,0,1,19.18-4.63,22.77,22.77,0,0,1,9.07,4.34A22.35,22.35,0,0,1,281,60.76Zm0,0A22,22,0,0,0,263.34,39.2a22,22,0,0,0-9.89.3,21.73,21.73,0,0,0-8.73,4.56A22.91,22.91,0,0,0,238.88,52a21.82,21.82,0,0,0-1.82,9.63A22.29,22.29,0,0,0,239.62,71l.11.21-.1.21-4.57,10.12-.51-.6,10.91-2.7.17,0,.13.1a21.85,21.85,0,0,0,11.13,4.35,20.44,20.44,0,0,0,3,0,21.34,21.34,0,0,0,8.79-2.23,20.7,20.7,0,0,0,5-3.42,24.47,24.47,0,0,0,2.13-2.19,26.78,26.78,0,0,0,1.77-2.49A22.38,22.38,0,0,0,281,60.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.33,63.17v2.45a1.8,1.8,0,0,1-1.85,1.85,1.84,1.84,0,0,1-1.84-1.85V61.71s0,0,0-.08,0,0,0-.07a1.9,1.9,0,0,1,1.84-1.85,4.22,4.22,0,1,0,0-8.43,4.16,4.16,0,0,0-3.61,2.07,1.87,1.87,0,0,1-2.56.68,1.84,1.84,0,0,1-.64-2.53,7.91,7.91,0,1,1,8.66,11.67Zm0,8.25v.68a1.8,1.8,0,0,1-1.85,1.84,1.84,1.84,0,0,1-1.84-1.84v-.68a1.87,1.87,0,0,1,1.84-1.85A1.83,1.83,0,0,1,260.33,71.42Z",
    style: {
      fill: "#FDE6C7"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCuate);
export default __webpack_public_path__ + "static/media/Empty-cuate.342145623750b8b8fa5eaa281a1b11db.svg";
export { ForwardRef as ReactComponent };